<template>
  <div class="checkout-overlay-expanded-content">
    <slot />
  </div>
</template>

<style lang="scss" scoped>
  @import '~stylesheets/meta.scss';

  .checkout-overlay-expanded-content {
    margin: -20px;
    padding-top: 20px;
    position: relative;
  }
</style>

<script>
  export default {
    name: 'checkout-overlay-expanded-content'
  }
</script>
